export default {
    parent: 'ApplicationLayout',
    template: `
        <header-review class="header-wrapper header-fixed" />
        <ui-view class="body-wrapper"></ui-view>
        <footer class="footer-wrapper"></footer>
    `
};



// WEBPACK FOOTER //
// ./src/app/layouts/review/index.js